/* UI-DESIGN: sample lobbies for reviewing the lobby design without logging in
   or a live game (Taco 2026-10-10). Same idea as /game/sample-host:
   - /lobby?gameId=sample-lobby       → inviting, roles half assigned
   - /lobby?gameId=sample-lobby-live  → in progress, round 2
   Frontend-only; the action buttons still call the API and will fail here. */
import { GameState, type Game, type Player, type Role } from "../../types/game";

const role = (objectId: string, name: string): Role => ({
  objectId, name, description: "", passport_number: "", nationality: "", date_of_birth: "",
  character_sheet_url: "", relationships: [], character_info: "",
});
const ROLES = [
  role("sample-role-1", "The Heiress"),
  role("sample-role-2", "The Manager"),
  role("sample-role-3", "The Spa Therapist"),
  role("sample-role-4", "The Influencer"),
];
const player = (i: number, name: string, attendance: boolean, email_sent: boolean, r: Role | null): Player => ({
  objectId: `sample-player-${i}`, name, email: `${name.split(" ")[0].toLowerCase()}@example.com`,
  phone_number: "", role: r as Role, interrogation_tokens: 3, email_sent, attendance, round_updates: [],
});
const PLAYERS = [
  player(1, "Sarah Davies", true, true, ROLES[0]),
  player(2, "Marcus Chen", true, true, ROLES[1]),
  player(3, "Eva Romero", false, true, null),
  player(4, "Theo Blackwood", true, false, null),
];
const BASE: Game = {
  objectId: "sample-lobby",
  name: "Sarah's Birthday Mystery",
  game_state: GameState.INVITING,
  current_round: 0,
  mystery: {
    objectId: "case-b", name: "White Lotus", intro_text: "", image_url: "",
    description: "A resort week ends with one guest missing from the group photo.",
    number_of_players: 8, number_of_rounds: 4, roles: ROLES,
  },
  players: PLAYERS,
  host: { first_name: "Sarah", last_name: "Davies" },
  rsvp: null,
  is_host: true,
  my_character: null,
};

export const SAMPLE_LOBBIES: Record<string, Game> = {
  "sample-lobby": BASE,
  "sample-lobby-live": { ...BASE, objectId: "sample-lobby-live", game_state: GameState.IN_PROGRESS, current_round: 2 },
};
